"use client";

import { useEffect, useRef, useState } from "react";
import useEnvVariables, {
  EnvVariablesType,
} from "@/libs/shared/hooks/useEnvVariables";
import { PaddleConfig } from "@/libs/shared/components/Paddle/Paddle.utils";
import { useFeatureFlagsContext } from "@/libs/shared/providers/FeatureFlagsProvider";

type PaddleRetainProps = {
  requireCustomerId?: boolean;
};

const PaddleRetain = ({ requireCustomerId = false }: PaddleRetainProps) => {
  const env = useEnvVariables() as EnvVariablesType;
  const [isPaddleLoaded, setIsPaddleLoaded] = useState(false);
  const { flags } = useFeatureFlagsContext();

  const initializedEmptyIdRef = useRef(false);
  const initializedRealIdRef = useRef(false);

  const initializePaddle = (customerId: string) => {
    if (
      !window.Paddle ||
      env?.NEXT_PUBLIC_ENV !== "production" ||
      !env?.PADDLE_API_KEY
    )
      return;

    window.Paddle.Initialize({
      token: env.PADDLE_API_KEY,
      pwCustomer: { id: customerId },
    } as PaddleConfig);
  };

  useEffect(() => {
    if (
      !isPaddleLoaded &&
      env?.NEXT_PUBLIC_ENV === "production" &&
      env?.PADDLE_API_KEY
    ) {
      const script = document.createElement("script");
      script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
      script.async = true;

      script.onload = () => {
        setIsPaddleLoaded(true);
      };

      script.onerror = () => {
        console.error("Failed to load Paddle script");
      };

      document.body.appendChild(script);
      return () => script.remove();
    }
  }, [isPaddleLoaded, env]);

  useEffect(() => {
    if (
      !isPaddleLoaded ||
      env?.NEXT_PUBLIC_ENV !== "production" ||
      !env?.PADDLE_API_KEY
    )
      return;

    const customerId = flags?.paddle_customer_id || "";

    // se requireCustomerId = false, inizializza solo se siamo esattamente sul base url ("/")
    if (!requireCustomerId && window.location.pathname !== "/") {
      return;
    }

    if (requireCustomerId) {
      if (customerId && !initializedRealIdRef.current) {
        initializePaddle(customerId);
        initializedRealIdRef.current = true;
      }
    } else {
      if (!customerId && !initializedEmptyIdRef.current) {
        initializePaddle("");
        initializedEmptyIdRef.current = true;
      }

      if (customerId && !initializedRealIdRef.current) {
        initializePaddle(customerId);
        initializedRealIdRef.current = true;
      }
    }
  }, [isPaddleLoaded, env, flags, requireCustomerId]);

  return null;
};

export default PaddleRetain;
